import React, { useContext, useEffect, useRef, useState } from 'react';
import axiosClient from '../../config/axiosClient';
import TeacherContext from '../../context/teacher/teacherContext';
import EvaluationContext from '../../context/evaluation/evaluationContext';
import {Button, Modal, Table, TableContainer, TableHead, TableCell, TableBody, TableRow, Tooltip} from '@material-ui/core';
import { Delete } from '@material-ui/icons';
import * as AiIcons from 'react-icons/ai';
import Box from '@material-ui/core/Box';
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import ListaEvaluaciones from '../modal/ListaEvaluaciones';
import {FormatListNumbered} from '@material-ui/icons';
import {makeStyles} from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    modal: {
        position: 'absolute',
        width: '70%',
        height: '70%',
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        borderRadius: 10,
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        overflowY: 'scroll'
    },
    modalAlerta: {
        position: 'absolute',
        width: 600,
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        borderRadius: 10,
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        overflowY: 'scroll'
    },
    icono:{
        cursor: 'pointer'
    }
}));

const capitalize = (s) => {
    if (typeof s !== 'string') return ''
    return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase()
}

function ListaMentores() {

    useEffect(() => {
        listarTeachers();
        // eslint-disable-next-line
    },[]);

    const styles= useStyles();

    const teacherContext = useContext(TeacherContext);
    const { allTeachers, listarTeachers } = teacherContext;

    const evaluationContext = useContext(EvaluationContext);
    const { obtenerEvaluaciones } = evaluationContext;

    const tablaMentores = useRef(null);

    const [ idTeacher, setIdTeacher ] = useState(null);
    const [ modalEliminar, setModalEliminar ] = useState(false);
    const [ modalEliminarTodos, setModalEliminarTodos ] = useState(false);
    const [ modalEvaluaciones, setModalEvaluaciones ] = useState(false);

    const abrirCerrarModalEvaluaciones=()=>{
        setModalEvaluaciones(!modalEvaluaciones);
    }

    const consultarEvaluaciones=(id)=>{
        obtenerEvaluaciones(id);
        abrirCerrarModalEvaluaciones();
    }

    const bajaLogica=async()=>{
        await axiosClient.delete('/api/auth/logicDelete/' + idTeacher)
            .then(response=>{
                listarTeachers();
                abrirCerrarModalEliminar()
        }).catch(error => { console.log(error); })
    }

    const bajaLogicaTodos=async()=>{
        await axiosClient.delete('/api/auth/logicDeleteAll/Teacher')
            .then(response=>{
                listarTeachers();
                abrirCerrarModalEliminarTodos()
        }).catch(error => { console.log(error); })
    }

    const abrirCerrarModalEliminar=()=>{
        setModalEliminar(!modalEliminar);
    }

    const abrirCerrarModalEliminarTodos=()=>{
        setModalEliminarTodos(!modalEliminarTodos);
    }

    const eliminarUsuario=(id)=>{
        setIdTeacher(id);
        abrirCerrarModalEliminar();
    }

    const eliminarTodosUsuarios=()=>{
        abrirCerrarModalEliminarTodos();
    }

    const modalListaEvaluaciones = (
        <div className={styles.modal}>
            
            <div className="row" >
                <div className="col-12">
                    <ListaEvaluaciones />
                </div>
            </div>
        </div>
    )

    const bodyEliminar=(
        <div className={styles.modalAlerta}>
            <p>¿Está seguro que desea eliminar al mentor seleccionado? </p>
            <div align="right">
                <Button color="secondary" onClick={()=>bajaLogica()} >Sí</Button>
                <Button onClick={()=>abrirCerrarModalEliminar()}>No</Button>
            </div>
        </div>
    )

    const bodyEliminarTodos=(
        <div className={styles.modalAlerta}>
            <p>¿Está seguro que desea eliminar todos los mentores registrados? </p>
            <div align="right">
                <Button color="secondary" onClick={()=>bajaLogicaTodos()} >Sí</Button>
                <Button onClick={()=>abrirCerrarModalEliminarTodos()}>No</Button>
            </div>
        </div>
    )

    function Row(props) {
        const { row } = props;
        const [open, setOpen] = useState(false);
            
        return (
            <>
                <TableRow key={row._id}>
                    <TableCell>
                        <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
                            {open ? <AiIcons.AiOutlineUp /> : <AiIcons.AiOutlineDown />}
                        </IconButton>
                    </TableCell>
                    <TableCell>{capitalize(row.name)} {capitalize(row.last_name)}</TableCell>
                    <TableCell><span className="badge bg-light text-dark" >{row.email}</span><span className="badge bg-light text-dark" >{row.laboral_email}</span></TableCell>
                    <TableCell>
                        {row.industry.map((x, i) => (
                            <span className="badge bg-light text-dark" key={i} >▪ {x}</span>
                        )        
                    )}</TableCell>
                    <TableCell>
                        {row.area.map((x, i) => (
                            <span className="badge bg-light text-dark" key={i} >▪ {x}</span>
                        )        
                    )}</TableCell>
                    <TableCell>
                        <Tooltip title="Consultar evaluaciones realizadas">
                            <FormatListNumbered className={styles.icono} onClick={()=>consultarEvaluaciones(row._id)} />
                        </Tooltip>   
                        <Tooltip title="Eliminar usuario">
                            <Delete className={styles.icono} onClick={()=>eliminarUsuario(row._id)} />
                        </Tooltip>    
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>  
                        <Collapse in={open} timeout="auto" unmountOnExit>
                            <Box margin={1}>
                                <div className="card-group justify">
                                    <div className="card">
                                        <div className="card-body">
                                            <h6 className="card-title">Empresas donde ha laborado</h6>
                                            <p className="card-text">{row.companies}</p>
                                        </div>
                                    </div>
                                    <div className="card">
                                        <div className="card-body">
                                            <h6 className="card-title">Funciones</h6>
                                            <p className="card-text">{row.functions}</p>
                                        </div>
                                    </div>
                                </div>
                            </Box>
                        </Collapse>
                    </TableCell>
                </TableRow>
            </>
        );
    }

    return (
        <>
            <div className="container">
                <div className="row">
                    <div className="col-lg-12 col-md-12 col-sm-12">
                        <div className="card card-large">
                            <div className="card-header border-bottom">
                                <h5 className="m-0">Lista de Mentores inscritos</h5>
                            </div>

                            <div className="">
                                <Button 
                                    id="delete-users"
                                    startIcon={<Delete />}
                                    variant="contained"
                                    title="Eliminar todos los mentores"
                                    type="textSecondary"
                                    onClick={()=>eliminarTodosUsuarios()} />
                            </div>

                            <div className="card-body p-0 pb-3 text-center">
                                <TableContainer ref={tablaMentores} className="table-responsive">
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell/>
                                                <TableCell>Nombre</TableCell>
                                                <TableCell>Email registrados</TableCell>
                                                <TableCell>Industrias</TableCell>
                                                <TableCell>Áreas</TableCell>
                                                <TableCell>Acciones</TableCell>
                                            </TableRow>
                                        </TableHead>

                                        <TableBody>
                                        {allTeachers && allTeachers.map((row) => (
                                            <Row key={row._id} row={row} />
                                        ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>       
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br />
            <br />
            <br />

            <Modal
                open={modalEvaluaciones}
                onClose={abrirCerrarModalEvaluaciones}>
                    {modalListaEvaluaciones}
            </Modal>

            <Modal
                open={modalEliminar}
                onClose={abrirCerrarModalEliminar}>
                    {bodyEliminar}
            </Modal>

            <Modal
                open={modalEliminarTodos}
                onClose={abrirCerrarModalEliminarTodos}>
                    {bodyEliminarTodos}
            </Modal>
        </>
    )
}

export default ListaMentores